// Демо-данные окна «Входящие» (Inbox) для главной Hub.
// Окно повторяет экран приложения: папки входящих, жизненный цикл, командные и свои папки,
// вкладки «Чаты» и «Звонки» с честными пустыми состояниями.
import { t } from "@/lib/i18n";

export const inboxAppMeta = {
  plan: "Growth",
  trialEnds: t("3 ноября 2026"),
  trialDays: 6,
  timeZone: "Europe/Moscow",
  me: t("Виктор"),
  meInitials: t("В"),
  meRole: t("Администратор"),
};

// папки входящих — верхний блок левой колонки
export const inboxAppNav = [
  { id: "all", label: t("Все"), icon: "ri-inbox-line" },
  { id: "mine", label: t("Мои"), icon: "ri-user-line" },
  { id: "collaborations", label: t("Совместные"), icon: "ri-team-line" },
  { id: "unassigned", label: t("Нераспределённые"), icon: "ri-user-unfollow-line" },
  { id: "incoming-calls", label: t("Входящие звонки"), icon: "ri-phone-line" },
  { id: "ai-agent", label: t("Создать AI-агента"), icon: "ri-sparkling-line" },
];

// этапы жизненного цикла как папки входящих
export const inboxAppStages = [
  { id: "lead", label: t("Новый лид"), icon: "ri-user-add-line", tone: "neutral" },
  { id: "hot", label: t("Горячий лид"), icon: "ri-fire-line", tone: "hot" },
  { id: "payment", label: t("Оплата"), icon: "ri-bank-card-line", tone: "pay" },
  { id: "customer", label: t("Клиент"), icon: "ri-award-line", tone: "client" },
];

// к какому этапу и папке относится каждый демо-диалог (id совпадает с mocks/inbox.ts)
export const inboxAppDialogMeta = [
  { id: "anna", stage: "lead", mine: true, collab: false },
  { id: "igor", stage: "hot", mine: false, collab: true },
  { id: "maria", stage: "payment", mine: true, collab: false },
  { id: "sergey", stage: "hot", mine: true, collab: false },
  { id: "elena", stage: "lead", mine: false, collab: true },
  { id: "artem", stage: "customer", mine: true, collab: false },
  { id: "olga", stage: "payment", mine: false, collab: false },
  { id: "dmitry", stage: "customer", mine: true, collab: false },
];

export const inboxAppSorts = [
  { id: "open-new", label: t("Открытые, новые") },
  { id: "open-old", label: t("Открытые, старые") },
  { id: "unread", label: t("С непрочитанными") },
];

// пустые состояния: у каждой папки своё объяснение, чтобы экран не выглядел одинаково
export const inboxAppEmptyStates = {
  all: {
    title: t("Похоже, входящие пусты"),
    text: t("Вы сможете отвечать здесь, когда придут новые сообщения."),
    action: t("Подключить канал"),
    target: "channels",
  },
  mine: {
    title: t("Вам пока ничего не назначено"),
    text: t("Когда руководитель закрепит диалог за вами, он появится в этой папке."),
    action: t("Подключить канал"),
    target: "channels",
  },
  collaborations: {
    title: t("Совместных диалогов нет"),
    text: t("Здесь собираются переписки, в которых участвуют несколько сотрудников."),
    action: t("Подключить канал"),
    target: "channels",
  },
  unassigned: {
    title: t("Похоже, входящие пусты"),
    text: t("Вы сможете отвечать здесь, когда придут новые сообщения."),
    action: t("Подключить канал"),
    target: "channels",
  },
  "incoming-calls": {
    title: t("Входящих звонков нет"),
    text: t("Подключите телефонию — звонки появятся здесь вместе с записью разговора."),
    action: t("Подключить звонки"),
    target: "catalog",
  },
  lead: {
    title: t("На этапе «Новый лид» пусто"),
    text: t("Сюда попадут диалоги с контактами, которые только начали общение."),
    action: t("Подключить канал"),
    target: "channels",
  },
  hot: {
    title: t("На этапе «Горячий лид» пусто"),
    text: t("Здесь диалоги, где клиент уже готов обсуждать условия и сроки."),
    action: t("Подключить канал"),
    target: "channels",
  },
  payment: {
    title: t("На этапе «Оплата» пусто"),
    text: t("Сюда попадают переписки, где клиент ждёт счёт или подтверждение оплаты."),
    action: t("Подключить канал"),
    target: "channels",
  },
  customer: {
    title: t("Среди клиентов пока пусто"),
    text: t("Здесь остаются диалоги с теми, кто уже купил — для поддержки и повторных продаж."),
    action: t("Подключить канал"),
    target: "channels",
  },
};

export const inboxAppMembers = [
  { id: "m1", name: t("Виктор Лебедев"), role: t("Администратор") },
  { id: "m2", name: t("Дмитрий Орлов"), role: t("Менеджер") },
  { id: "m3", name: t("Алексей Ковалёв"), role: t("Агент") },
  { id: "m4", name: t("Ольга Смирнова"), role: t("Агент") },
];

export const inboxAppAgentSteps = [
  { icon: "ri-plug-line", title: t("Каналы"), text: t("Агент отвечает в WhatsApp, Telegram, почте и онлайн-чате.") },
  { icon: "ri-book-open-line", title: t("Источники знаний"), text: t("Опирается на прайсы, регламенты и шаблоны ответов компании.") },
  { icon: "ri-shield-check-line", title: t("Передача человеку"), text: t("Сложный вопрос сразу уходит продавцу с заметкой о контексте.") },
];

export const inboxAppAgentRoles = [
  t("Отвечать на первые сообщения"),
  t("Собирать заявки"),
  t("Записывать на консультацию"),
  t("Поддерживать клиентов"),
];

export const inboxAppHints = [
  {
    icon: "ri-folder-line",
    title: t("Папки вместо хаоса"),
    text: t("Диалоги раскладываются по ответственным и этапам жизненного цикла — не нужно искать вручную."),
  },
  {
    icon: "ri-filter-3-line",
    title: t("Фильтр «Без ответа»"),
    text: t("Одно переключение оставляет только переписки, где последним писал клиент."),
  },
  {
    icon: "ri-phone-line",
    title: t("Звонки рядом с чатами"),
    text: t("Вкладка «Звонки» показывает историю разговоров в той же папке, что и переписка."),
  },
];
